import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  Grid,
  Button,
  Toolbar,
  Typography,
  withStyles,
} from '@material-ui/core'
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Warning as WarningIcon,
} from '@material-ui/icons'

import { getOrder, getOrderUsers } from '../actions/order'
import { navigate, triggerCancelOrder } from '../actions/app'
import { LIST_TYPE, ROUTES } from '../constant'
import Line from '../components/Line'
import Inline from '../components/Inline'
import Loading from '../components/Loading'
import Section from '../components/Section'
import Breadcrumb from '../components/Breadcrumb'
import TableAutomation from '../components/TableAutomation'
import ModalConfirm from '../components/ModalConfirm'


const styles = theme => ({
  root: {
    paddingTop: 0,
    padding: theme.spacing(1),
  },
  marginTop: {
    marginTop: theme.spacing(1),
  },
  sectionItem: {
    width: '100%',
  },
  preLine: {
    whiteSpace: 'pre-line',
  },
  content: {
    paddingBottom: theme.spacing(1),
  },
  section: {
    flex: 1,
    marginRight: theme.spacing(1),
  },
  sectionInfo: {
    width: 350,
  },
  flex1: {
    flex: 1,
  },
  header: {
    color: 'white',
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
  },
  headerIcon: {
    marginRight: theme.spacing(1),
  },
})


class Order extends Component {
  /* ATTRIBUTES */

  state = {
    modalOpened: false,
  }


  /* LIFECYCLE */

  /**
   * @componentWillMount
   */
  componentWillMount() {
    const { uid } = this.props.match.params

    if (uid) {
      this.props.getOrder(uid)
    }
  }

  /**
   * @componentWillReceiveProps
   * @param {*} nextProps - Next properties of the Component
   */
  componentWillReceiveProps(nextProps) {
    const { uid } = nextProps.match.params

    if (uid && uid !== this.props.match.params.uid) {
      this.props.getOrder(uid)
    }
  }


  /* METHODS */

  handleChange = e => this.setState({ [e.target.name]: e.target.value })

  handleOrderUsers = (options = {}) => this.props.getOrderUsers(this.props.item.id, options)

  handleEditOrder = () => this.props.navigate(`${ROUTES.ORDER}/add?uid=${this.props.item.id}`)

  handleOpenModal = () => this.setState({ modalOpened: true })

  handleCloseModal = () => this.setState({ modalOpened: false })

  handleCancelOrder = () => {
    this.handleCloseModal()
    this.props.triggerCancelOrder(this.props.item.id)
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      item,
      classes,
      isLoading,
    } = this.props

    const {
      modalOpened,
    } = this.state

    const users = (item && item.users) || {
      items: [],
      hasMore: false,
      hasPrevious: false,
      startAfter: null,
      endBefore: null,
    }

    return (
      <div className={classes.root}>
        <Breadcrumb
          data={[
            { label: 'Accueil', to: '/' },
            { label: 'Commandes', to: ROUTES.ORDER },
            'Commande',
          ]}
        />

        {isLoading && <Loading />}

        {item && item.canceled && (
          <Toolbar className={classes.header}>
            <WarningIcon className={classes.headerIcon} />
            <Typography variant="h3">La commande est actuellement annulé</Typography>
          </Toolbar>
        )}

        <Grid container direction="row" wrap="nowrap" className={classes.content}>
          <Grid container direction="column" alignItems="center" className={classes.section}>
            <Section title="Utilisateurs" className={classes.sectionItem}>
              {item && (
                <TableAutomation
                  disableMargin
                  {...users}
                  request={this.handleOrderUsers}
                  head={['Utilisateur', 'Email', 'Crédit', 'Date d\'ajout', 'Solde']}
                  onClick={(user) => this.props.navigate(`${ROUTES.USER}/${user.id}`)}
                  row={(user) => {
                    const balance = user.wallets.find(b => b.order_id === item.id)

                    return [
                      { data: user.phone, display: <Link to={`${ROUTES.USER}/${user.id}`}>{user.phone}</Link> },
                      user.email,
                      balance ? `${balance.initial_amount} €` : 'N/A',
                      balance ? moment(balance.created_at).format('DD/MM/YYYY') : 'N/A',
                      balance ? `${balance.available_amount} €` : 'N/A',
                    ]
                  }}
                />
              )}
            </Section>
          </Grid>


          <Grid container direction="column" alignItems="center" className={classes.sectionInfo}>
            <Section title="Informations" className={classes.sectionItem}>
              {item && (
                <>
                  <Typography align="center" variant="h6">{item.client.name}</Typography>
                  <Line>Dernières commandes</Line>
                </>
              )}
            </Section>

            <Section title="Faturation" className={classes.sectionInfo}>
              {item && (
                <>
                  <Inline>
                    <Typography>Numéro Facture: </Typography>
                    <Typography variant="caption">{item.bill_number}</Typography>
                  </Inline>
                  <Inline>
                    <Typography>Mode de règlement: </Typography>
                    <Typography variant="caption">{item.payment_choice}</Typography>
                  </Inline>
                  <Inline>
                    <Typography>Frais techniques:</Typography>
                    <Typography variant="caption">{item.technical_costs} €</Typography>
                  </Inline>
                  <br />
                  <Typography>Informations complémentaires:</Typography>
                  <Typography variant="caption">{item.informations}</Typography>
                </>
              )}
            </Section>

            <Section title="Actions" className={classes.sectionInfo}>
              {item && (
                <>
                  <Button
                    fullWidth
                    color="secondary"
                    variant="contained"
                    onClick={this.handleEditOrder}
                  >
                    <EditIcon /><span className={classes.flex1}>Modifier</span>
                  </Button>

                  <br /><br />
                  <Button
                    fullWidth
                    color="primary"
                    variant="contained"
                    disabled={item.canceled}
                    onClick={this.handleOpenModal}
                  >
                    <DeleteIcon /><span className={classes.flex1}>Annuler</span>
                  </Button>
                </>
              )}
            </Section>
          </Grid>
        </Grid>

        <ModalConfirm
          open={modalOpened}
          title="Annuler une commande"
          onClose={this.handleCloseModal}
          isLoading={this.props.isLoading}
          onSubmit={this.handleCancelOrder}
          submitLabel="Confirmer l'annulation"
        >
          <Typography>Êtes-vous sûr de vouloir annuler cette commande ?</Typography>
        </ModalConfirm>
      </div>
    )
  }
}


Order.propTypes = {
  item: PropTypes.object,
  navigate: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  getOrder: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  getOrderUsers: PropTypes.func.isRequired,
  triggerCancelOrder: PropTypes.func.isRequired,
}


const mapStateToProps = state => ({
  isLoading: state.app.isLoading,
  item: state.item.type === LIST_TYPE.ORDERS ? state.item : null,
})


export default connect(mapStateToProps, {
  getOrder,
  navigate,
  getOrderUsers,
  triggerCancelOrder,
})(withStyles(styles)(Order))
